import { z } from 'zod';

export const passwordSchema = z
  .string()
  .min(6, { message: 'Das Passwort muss mindestens 6 Zeichen lang sein.' });
